<template>
    <div>
         <b-button variant="primary" @click="modal.show = true">{{ $t('edit') }}</b-button>

        <b-modal size="lg" title="Action" v-model="modal.show" hide-footer>
            <b-form-group
                label-for="fcmToken"
                :label-cols="0"
                :horizontal="true">
                <b-form-radio-group id="fcmToken"
                :plain="true"
                :options="[
                    {text: 'Token',value: 'token'},
                    {text: 'Condition',value: 'condition'},
                    {text: 'Topic',value: 'topic'}
                ]"
                v-model="content.fcmToken"
                :checked="3">
                </b-form-radio-group>
            </b-form-group>

            <InputField
                    :label-cols="0"
                    type="text" :name="content.fcmToken" v-model="content[content.fcmToken]"
                        :rules="{required: true, length: {min: 2, max: 255}}"
                        :helpTip="{id: 'event.operation.mustache', text: this.$t('usePlaceholders')}"
                />

            <InputField type="text" name="title" :label="this.$t('title')" v-model="content.title" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="body" :label="this.$t('body')" v-model="content.body" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="icon" :label="this.$t('icon')" v-model="content.icon" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="image" :label="this.$t('image')" v-model="content.image" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="sound" :label="this.$t('sound')" v-model="content.sound" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

             <InputField type="text" name="color" :label="this.$t('color')" v-model="content.color" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

             <InputField type="text" name="badge" :label="this.$t('badge')" v-model="content.badge" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="tag" :label="this.$t('tag')" v-model="content.tag" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="click_action" :label="this.$t('clickAction')" v-model="content.click_action" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="priority" :label="this.$t('priority')" v-model="content.priority" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="ttl" :label="this.$t('timeToLive')" v-model="content.ttl" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}, default: 2419200}"
            />

            <SelectField name="content_available" :label="this.$t('contentAvailable')" v-model="content.content_available" @error="fieldError"
                :items="[true, false]"
                :rules="{required: false}"
            />

            <SelectField name="mutable_content" :label="this.$t('mutableContent')" v-model="content.mutable_content" @error="fieldError"
                :items="[true, false]"
                :rules="{required: false}"
            />

            <SelectField name="delay_while_idle" :label="this.$t('dwi')" v-model="content.delay_while_idle" @error="fieldError"
                :items="[true, false]"
                :rules="{required: false}"
                :description="this.$t('delayIdle')"
            />

            <h3>APNS</h3>

            <InputField type="text" name="launch_image" :label="this.$t('launchImage')" v-model="content.apns.launch_image" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

            <InputField type="text" name="category" :label="this.$t('category')" v-model="content.apns.category" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />

            <h3>Android</h3>

            <InputField type="text" name="channel_id" :label="this.$t('channelId')" v-model="content.android.channel_id" @error="fieldError"
                :rules="{required: false, length: {min: 2, max: 128}}"
            />
        </b-modal>
    </div>
</template>

<script>
import InputField from '@/components/form/Input'
import SelectField from '@/components/form/Select'
import CodeEditor from '@/components/form/Editor/Code'

export default {
    components: {
        InputField,
        SelectField,
        CodeEditor
    },
    props: {
       value: {
         type: Object
       }
    },
    computed: {
        content: {
            get() {
                this.value.apns = {}
                this.value.android = {}
                this.value.fcmToken = this.value.fcmToken || 'topic';

                return this.value || {};
            },

            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        save() {
            this.modal.show = false
        }
    },
    data: function() {
        return {
            errors: [],
            modal: {
                show: false
            }
        }
    },

    mounted() { }
}
</script>
